// Simple cache for organization role to prevent duplicate API calls
const roleCache = {
  data: null,
  orgName: null,
  timestamp: null,
  TTL: 5 * 60 * 1000, // 5 minutes
};

export const getCachedOrgRole = (orgName) => {
  // Check if cache is valid
  if (
    roleCache.data &&
    roleCache.orgName === orgName &&
    roleCache.timestamp &&
    Date.now() - roleCache.timestamp < roleCache.TTL
  ) {
    return roleCache.data;
  }
  return null;
};

export const setCachedOrgRole = (orgName, data) => {
  roleCache.data = data;
  roleCache.orgName = orgName;
  roleCache.timestamp = Date.now();
};

export const clearOrgRoleCache = () => {
  roleCache.data = null;
  roleCache.orgName = null;
  roleCache.timestamp = null;
};

